/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_EmptyInputs */

const en_templates_empty = /** @type {(inputs: Templates_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No templates yet.`)
};

const he_templates_empty = /** @type {(inputs: Templates_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`אין תבניות עדיין.`)
};

/**
* | output |
* | --- |
* | "No templates yet." |
*
* @param {Templates_EmptyInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const templates_empty = /** @type {((inputs?: Templates_EmptyInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_EmptyInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_empty(inputs)
	return he_templates_empty(inputs)
});